import { QueryStringBuilderFactoryModule } from '@b2c/common/factories/QueryStringBuilder/QueryStringBuilder.factory';
import { AuthServiceModule } from '@b2c/common/services/auth/auth.service';
import { HelpersServiceModule } from '@b2c/common/services/helpers/helpers.service';
import { MembershipServiceModule } from '@b2c/common/services/membership/membership.service';
import { OrdersServiceModule } from '@b2c/common/services/order/order.service';
import { ThemesServiceModule } from '@b2c/common/services/themes/themes.service';
import angular from 'angular';

export const MobileNavigationDirectiveModule = angular.module('acme.common.directive.mobileNavigation', [
  AuthServiceModule,
  ThemesServiceModule,
  MembershipServiceModule,
  OrdersServiceModule,
  HelpersServiceModule,
  QueryStringBuilderFactoryModule
])
.directive('mobileNavigation', [function() {

    return {
      restrict: 'A',
      replace: true,
      transclude: true,
      templateUrl: 'common/directives/mobileNavigation/mobileNavigation.tpl.html',
      scope: {},

      link: function($scope, $element, $attrs) {
        // Modified after controller runs
      },

      controller: ['$document', '$scope', '$state', 'AuthService', 'ThemesService', 'MembershipService', 'OrderService', 'QueryStringBuilderFactory', 'HelpersService', function($document, $scope, $state, AuthService, ThemesService, MembershipService, OrderService, QueryStringBuilderFactory, HelpersService) {

        $scope.mobileNavigation = {
          
          links: [],
          isLoggedIn: false,
          isMobile: false,
          isOpen: false,
          isVerified: false,
          allowMembershipLogin: false,
          allowMembershipSales: false,
          hideLogin: false,

          init: function() {
            this.isMobile = (window.CONFIG.mobile);
            this.links = ThemesService.getLinks();
            this.allowMembershipLogin = ThemesService.getCompany('membership');
            this.allowMembershipSales = ThemesService.getCompany('membershipSales');
            this.isVerified = MembershipService.checkVerifiedMembership($state.params.tenantId);
            this.hideLogin = this.getLoginSetting();

            $scope.$on('MobileNavigation::Toggle', this.onMobileNavigationToggle);
            $document.bind('click', this.onDocumentClick);
            $scope.$on('$destroy', this.onDestroy);
          },

          getLoginSetting: function() {
            var setting = ThemesService.getTextVariable('header-hide-login', false);
            return (setting === true || setting === "true");
          },

          getLogin: function() {
            var r = 'My orders';

            AuthService.getCookie();

            if (AuthService.cookie) {
              this.isLoggedIn = true;
              r = AuthService.cookie.email;
            }

            return r;
          },

          getMember: function() {
            var r = 'My Membership',
                name,
                member;

            if (this.isVerified) {
             
              member = MembershipService.getVerifiedMember() || MembershipService.getPrimaryMember();

              if (member) {
                name = MembershipService.getMemberName(member);
              }

              r = 'Member: ' + name;
            }

            return r;
          },

          launchLogin: function() {
            if (this.isLoggedIn) {
              HelpersService.setHref(HelpersService.makeUrl(['/account', $state.params.tenantId, 'orders']));
            } else if (window.location.pathname.match(/^\/auth/)) {
              HelpersService.setHref(HelpersService.makeUrl(['/auth', $state.params.tenantId, 'login']));
            } else {
              var ref = window.location.href;
              HelpersService.setHref(HelpersService.makeUrl(['/auth', $state.params.tenantId, 'login'], { ref: ref }));
            }
          },

          launchVerify: function() {
            var qs,
              member = MembershipService.getVerifiedMember();

            if (member) {
              if (this.allowMembershipSales) {
                HelpersService.setHref('/membership/' + $state.params.tenantId + '/profile?membershipId=' + member.membershipId + HelpersService.appendDonationParams());
              } else {
                qs = new QueryStringBuilderFactory({
                  props: {
                    eventId: $state.params.eventId,
                    date: $state.params.date || OrderService.getDate()
                  },
                  fields: {
                    optional: ['date']
                  }
                });
                qs.query += (qs.query.length>0) ?  HelpersService.appendonationParams($state.params):  HelpersService.addDonationParams();
                HelpersService.setHref('/events/' + $state.params.tenantId + '/list' + qs.query);
              }
            } else {
              HelpersService.setHref('/auth/' + $state.params.tenantId + '/members' + HelpersService.addDonationParams());
            }
          },

          launchVerifyLogout: function() {
            HelpersService.setHref('/auth/' + $state.params.tenantId + '/members?logout=1' + HelpersService.appendDonationParams());
          },

          launchMembership: function() {
            const member = MembershipService.getVerifiedMember();
            HelpersService.setHref('/membership/' + $state.params.tenantId + '/profile?membershipId=' + member.membershipId + HelpersService.appendDonationParams());
          },

          launchLogout: function() {
            this.isLoggedIn = (AuthService.logout()) ? false : true;
            if (!this.isLoggedIn) {
              HelpersService.setHref('/events/' + $state.params.tenantId + '/list' + HelpersService.addDonationParams());
            }
          },

          onDocumentClick: function(e) {
            
            if ($scope.mobileNavigation.isOpen) {
              $scope.mobileNavigation.isOpen = false;
              $scope.$emit('App::NavigationUpdate', { event: e, state: $scope.mobileNavigation.isOpen });
              $scope.$apply();
            }
          },

          onMobileNavigationToggle: function(e, data) {
            data.event.stopPropagation();
            $scope.mobileNavigation.isOpen = !$scope.mobileNavigation.isOpen;
            $scope.$emit('App::NavigationUpdate', { event: e, state: $scope.mobileNavigation.isOpen });
          },

          onDestroy: function(e, data) {
            $document.unbind('click');
          }

        };

        $scope.mobileNavigation.init();

      }]

    };

}]).name;